/**
 * The push token this app registered with the API, kept so signing out can
 * unregister the phone: the next person using it must not get your notifications.
 */
let currentPushToken: string | null = null

export const setCurrentPushToken = (token: string | null): void => {
  currentPushToken = token
}

export const getCurrentPushToken = (): string | null => currentPushToken

/** IANA time zone of the phone (`Europe/Brussels`), so reminders ring at local hours. */
export const deviceTimeZone = (): string | undefined => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined
  } catch {
    return undefined
  }
}
